export default __webpack_public_path__ + "ondemand/static/e3056e037/media/favicon-32.png";